import { render, staticRenderFns } from "./cancelCard.vue?vue&type=template&id=405e582c&scoped=true&"
import script from "./cancelCard.vue?vue&type=script&lang=js&"
export * from "./cancelCard.vue?vue&type=script&lang=js&"
import style0 from "./cancelCard.vue?vue&type=style&index=0&id=405e582c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405e582c",
  null
  
)

export default component.exports